import { TFunction } from "i18next"
import { joinStrings } from "@/lib/joinString"
import { useCareProviderQuickListQuery$data } from "@/modules/care-provider/simple-search/services/__generated__/useCareProviderQuickListQuery.graphql"
import { HighlightsSearchObject } from "@/modules/care-provider/utils/combine-care-provider-title"
import { getHighlightValue } from "@/modules/care-provider/utils/get-highlight-value"

interface FormatCareProviderRelationName {
  relationTitle?: string | null
  relationBusinessName?: string | null
  relationFirstName?: string | null
  relationLastName?: string | null
  relationType?: string | null
  network?: useCareProviderQuickListQuery$data["ch_careProviderQuickList"]["personalCareProviders"][number]["network"]
  highlights?: HighlightsSearchObject
}

const getCareProviderRelationName = (
  {
    relationTitle,
    relationBusinessName,
    relationFirstName,
    relationLastName,
    relationType,
    network,
    highlights,
  }: FormatCareProviderRelationName,
  t: TFunction,
) => {
  if (relationType) {
    const relationName = joinStrings(
      [
        getHighlightValue(highlights, "relationBusinessName", relationBusinessName),
        relationTitle,
        getHighlightValue(highlights, "relationFirstName", relationFirstName),
        getHighlightValue(highlights, "relationLastName", relationLastName),
      ],
      " ",
    )

    return relationName ? joinStrings([t(`careProvider.${relationType}`), relationName], " ") : ""
  }

  if (network) {
    return joinStrings([t("careProvider.PartOfNetwork"), getHighlightValue(highlights, "name", network.name)], " ")
  }

  return ""
}

export { getCareProviderRelationName }
